import {
  BaseField,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  withConditional,
} from "@bleu.builders/ui";
import React from "react";

import { PhoneInput } from "#/components/PhoneInput";

interface PhoneFieldProps extends BaseField {}

export const PhoneField = withConditional<PhoneFieldProps>(
  ({ form, field }) => {
    return (
      <FormField
        control={form.control}
        name={field.name}
        render={({ field: formField }) => (
          <FormItem className="flex flex-col items-start">
            <FormLabel className="text-left">Telefone</FormLabel>
            <FormControl className="w-full">
              <PhoneInput
                placeholder="Digite seu número de telefone"
                defaultCountry="BR"
                countryCallingCodeEditable={false}
                value={field.value}
                defaultValue={field.value}
                countries={["BR"]}
                {...formField}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  },
);
